import React from "react";
import ReactDOM from "react-dom";
import * as $ from 'jquery'

export const FilePreview = (props) => {
  const { id, imageUrl, label } = props
  const modalId = `file-preview-${id}`

  const modalClose = () => {
    $(`#${modalId}`).modal('hide')
  }

  const previewModal = (
    <div
      className="modal fade"
      id={modalId}
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{ zIndex: 999999 }}
    >
      <div
        className="modal-dialog modal-lg"
        role="document"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          margin: 0,
          minWidth: 'auto',
          maxWidth: '800px',
          width: '90%',
        }}
      >
        <div className="modal-content">
          <div className="modal-header py-5">
            <h5 className="modal-title" id="exampleModalCenterTitle">{label}</h5>
            <div className="d-flex">
              <a href={imageUrl} download={true} className="btn btn-outline-primary mx-6">Download</a>
              <button type="button" className="close py-5" onClick={modalClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>

          <div className="modal-body">
            <embed style={{ width: "100%", height: '550px', objectFit: 'fit' }} src={imageUrl}></embed>
          </div>
        </div>
      </div>
    </div>
  );

  // Render on body so it centers on the viewport (not inside another modal)
  if (typeof document !== 'undefined') {
    return ReactDOM.createPortal(previewModal, document.body)
  }

  return previewModal
};

export default FilePreview;
